var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close button icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.8%",
    y: "-23.4%",
    width: "165.6%",
    height: "165.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v",
    transform: "translate(-1481.000000, -257.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(1487.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "X-Medium",
    transform: "translate(7.000000, 7.000000)",
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.999650, 1.999750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42125,7.00025 L12.49825,2.92325 L13.70725,1.71425 C14.09825,1.32325 14.09825,0.69025 13.70725,0.30025 L13.70025,0.29325 C13.31025,-0.09775 12.67725,-0.09775 12.28625,0.29325 L11.07725,1.50225 L8.39525,4.18525 L7.00025,5.57925 L3.56725,2.14625 L1.71425,0.29325 C1.32325,-0.09775 0.69125,-0.09775 0.30025,0.29325 L0.29325,0.30025 C-0.09775,0.69025 -0.09775,1.32325 0.29325,1.71425 L5.57925,7.00025 L1.50225,11.07725 L0.29325,12.28625 C-0.09775,12.67725 -0.09775,13.31025 0.29325,13.70025 L0.30025,13.70725 C0.69125,14.09825 1.32325,14.09825 1.71425,13.70725 L7.00025,8.42125 L10.43425,11.85525 L10.43525,11.85525 L12.28625,13.70725 C12.67725,14.09825 13.31025,14.09825 13.70025,13.70725 L13.70725,13.70025 C14.09825,13.31025 14.09825,12.67725 13.70725,12.28625 L8.42125,7.00025 Z",
    id: "x",
    fill: "#1C1C1C"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.5ed2ace18628fa6d5edf460fe926ebf6.svg";
export { ForwardRef as ReactComponent };